import React from "react";
import {
  Grid,
  TextField, MenuItem
} from "@mui/material";
import { DutTestpoint } from "../../models/signalSources/dutTestpoint.ts";
import { useContact } from "../../hooks/useContact.ts";
import { useSideOptions } from "../../hooks/useSideOptions.ts";
import { useUnitOptions } from "../../hooks/useUnitOptions.ts";

interface Props {
  data: DutTestpoint;
  setIsValid: (isValid: boolean) => void;
  onChange: (field: keyof DutTestpoint, value: any ) => void;
}

const EditDutTestpointFormView: React.FC<Props> = ({ data, setIsValid, onChange}) => {
  const { options: contact } = useContact();
  const { options: sideOptions } = useSideOptions();
  const { options: unitOptions } = useUnitOptions();

  const handleContactChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const selectedDescription = e.target.value;
    const selectedContact = contact.find(
      (option) => option.description === selectedDescription
    );
    if (selectedContact) {
      onChange("contact", selectedContact);
    }
  };

  const handleChange = (field: keyof DutTestpoint, value: any) => {
    onChange(field, value);
    if (field === "name") {
      if (value === "" || data.net === "") {
        setIsValid(false);
      }
      else {
        setIsValid(true);
      }
    }
    else if (field === "net") {
      if (value === "" || data.name === "") {
        setIsValid(false);
      }
      else {
        setIsValid(true);
      }
    }
    else {
      if (data.net === "" || data.name === "") {
        setIsValid(false)
      }
      else {
        setIsValid(true);
      }
    }
  };

  return (
    <Grid container spacing={2} sx={{ mt: 2 }}>
      <Grid size={5}>
        <TextField 
          fullWidth 
          required 
          label="X Koordinate" 
          type="number" inputProps={{ step: 0.01}} 
          value={data.x} 
          onChange={(e) => handleChange("x", e.target.value)} InputLabelProps={{ shrink: true }} 
        />
      </Grid>
      <Grid size={5}>
        <TextField 
          fullWidth 
          required 
          label="Y Koordinate" 
          type="number" inputProps={{ step: 0.01}} 
          value={data.y} 
          onChange={(e) => handleChange("y", e.target.value)} InputLabelProps={{ shrink: true }} 
        />
      </Grid>
      <Grid size={2}>
        <TextField 
          fullWidth 
          required 
          select 
          label="Unit" 
          value={unitOptions.includes(data.unit) ? data.unit : ""}
          onChange={(e) => handleChange("unit", e.target.value)}
        >
          {(unitOptions || []).map((option) => (
            <MenuItem key={option} value={option}>{option}</MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={6}>
        <TextField 
          fullWidth 
          required 
          label="Testpunkt Name" 
          value={data.name} onChange={(e) => handleChange("name", e.target.value)} 
        />
      </Grid>
      <Grid size={6}>
        <TextField 
          fullWidth 
          required 
          label="Netz Name" 
          value={data.net} 
          onChange={(e) => handleChange("net", e.target.value)} 
        />
      </Grid>
      <Grid size={6}>
        <TextField 
          fullWidth
          required
          select 
          label="Layer" 
          value={sideOptions.includes(data.side) ? data.side : ""}
          onChange={(e) => handleChange("side", e.target.value)}
          >
          {(sideOptions || []).map((option) => (
            <MenuItem key={option} value={option}>{option}</MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={6}>
        <TextField 
          fullWidth 
          required 
          select 
          label="Kontakt" 
          value={
            contact.some(opt => opt.description === data.contact?.description)
              ? data.contact.description
              : ""
          }
          onChange={(e) => handleContactChange(e)}>
          {(contact || []).map((option) => (
            <MenuItem key={option.id} value={option.description}>{option.description}</MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  );
};

export default EditDutTestpointFormView;